import { render, staticRenderFns } from "./DocumentoWindow.vue?vue&type=template&id=75a2e536&"
import script from "./DocumentoWindow.vue?vue&type=script&lang=js&"
export * from "./DocumentoWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports